class SubProductCard extends HTMLElement {
  constructor() {
    super()
    this.productId = this.dataset.productId
    this.selectWrapper = this.querySelector(".sub-product-card__select-wrapper")
    this.selectTrigger = this.querySelector(".sub-product-card__select-trigger")
    this.selectOptions = this.querySelectorAll(
      ".sub-product-card__select-option"
    )
    this.selectInputs = this.querySelectorAll(".sub-product-card__select-input")
    this.selectValue = this.querySelector(".sub-product-card__select-value")

    this.quantityInput = this.querySelector(".sub-product-card__quantity-input")
    this.quantityMinus = this.querySelector(".sub-product-card__quantity-minus")
    this.quantityPlus = this.querySelector(".sub-product-card__quantity-plus")

    this.form = this.querySelector(".sub-product-form")

    this.init()
  }

  init() {
    if (this.selectTrigger) {
      this.selectTrigger.addEventListener(
        "click",
        this.toggleDropdown.bind(this)
      )
    }

    this.selectOptions.forEach((option) => {
      option.addEventListener("click", this.handleOptionClick.bind(this))
    })

    if (this.quantityMinus) {
      this.quantityMinus.addEventListener(
        "click",
        this.decreaseQuantity.bind(this)
      )
    }

    if (this.quantityPlus) {
      this.quantityPlus.addEventListener(
        "click",
        this.increaseQuantity.bind(this)
      )
    }

    if (this.quantityInput) {
      this.quantityInput.addEventListener(
        "change",
        this.handleQuantityChange.bind(this)
      )
    }

    if (this.form) {
      this.form.addEventListener("submit", this.handleSubmit.bind(this))
    }

    document.addEventListener("click", this.handleOutsideClick.bind(this))
  }

  toggleDropdown(e) {
    e.preventDefault()
    const isOpen = this.selectWrapper.classList.contains("is-open")

    if (isOpen) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  openDropdown() {
    const triggerHeight = this.selectTrigger.offsetHeight
    const dropdown = this.querySelector(".sub-product-card__select-dropdown")
    if (dropdown) {
      dropdown.style.bottom = `${triggerHeight - 1}px`
    }
    this.selectWrapper.classList.add("is-open")
    this.selectTrigger.setAttribute("aria-expanded", "true")
  }

  closeDropdown() {
    this.selectWrapper.classList.remove("is-open")
    this.selectTrigger.setAttribute("aria-expanded", "false")
  }

  handleOptionClick(e) {
    e.preventDefault()
    const option = e.currentTarget
    const input = option.querySelector(".sub-product-card__select-input")
    const label = option.querySelector(
      ".sub-product-card__select-label"
    ).textContent

    this.selectOptions.forEach((opt) => opt.classList.remove("is-selected"))
    option.classList.add("is-selected")

    this.selectInputs.forEach((inp) => (inp.checked = false))
    input.checked = true

    this.selectValue.textContent = label

    this.closeDropdown()
  }

  handleOutsideClick(e) {
    if (this.selectWrapper && !this.selectWrapper.contains(e.target)) {
      this.closeDropdown()
    }
  }

  decreaseQuantity() {
    const currentValue = parseInt(this.quantityInput.value) || 1
    if (currentValue > 1) {
      this.quantityInput.value = currentValue - 1
      this.updateQuantityButtons()
    }
  }

  increaseQuantity() {
    const currentValue = parseInt(this.quantityInput.value) || 1
    this.quantityInput.value = currentValue + 1
    this.updateQuantityButtons()
  }

  handleQuantityChange() {
    const value = parseInt(this.quantityInput.value)
    if (isNaN(value) || value < 1) {
      this.quantityInput.value = 1
    }
    this.updateQuantityButtons()
  }

  updateQuantityButtons() {
    const value = parseInt(this.quantityInput.value)
    if (this.quantityMinus) {
      this.quantityMinus.disabled = value <= 1
    }
  }

  handleSubmit(e) {
    e.preventDefault()

    if (window.funkinPurchaseMode && window.funkinAmazonUrl) {
      window.open(window.funkinAmazonUrl, '_blank', 'noopener,noreferrer')
      return
    }

    const formData = new FormData(this.form)
    const selectedPlan = this.querySelector(
      ".sub-product-card__select-input:checked"
    )

    if (selectedPlan) {
      formData.append("selling_plan", selectedPlan.value)
    }

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent("cart:item-added", { detail: data })
        )

        if (window.theme && window.theme.cart && window.theme.cart.refresh) {
          window.theme.cart.refresh()
        }
      })
      .catch((error) => {
        console.error("Error adding to cart:", error)
      })
  }
}

if (!customElements.get("sub-product-card")) {
  customElements.define("sub-product-card", SubProductCard)
}
